import { client } from '@whizz/api-client';
import { apiError } from '@whizz/logger';
import { useIdentity } from '@whizz/react-identity';
import { useEffect } from 'react';

const LogApiErrors = ({ children }: { children: unknown }): JSX.Element => {

  const { identity } = useIdentity();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const interceptor = client.http().interceptors.response.use(null, (err) => {
      apiError(err, { identity: identity && identity.claims ? (identity.claims as { sub: unknown, usr: unknown }).sub : undefined });
      return Promise.reject(err);
    });

    return () => {
      client.http().interceptors.response.eject(interceptor);
    };

  }, [ identity ]);

  return children as JSX.Element;
};

export default LogApiErrors;
